export default __webpack_public_path__ + "static/media/nishant.64ba5e8c.jpg";